const CLICK_WHATSAPP_BUTTON = 'click-whatsapp-button';

export {CLICK_WHATSAPP_BUTTON};